
export default [{
  path: '/Example',
  component: () => import('vue-router').then(m => m.RouterView),
  meta: { debug: true },
  children: [
    {
      path: '',
      name: 'Example',
      component: () => import('@/components/examples/Example.vue'),
      meta: { debug: true }
    },
    {
      path: 'AllCompsExample',
      name: 'AllCompsExample',
      component: () => import('@/components/examples/AllCompsExample.vue'),
      meta: { debug: true }
    },
    {
      path: 'DialogPluginExample',
      name: 'DialogPluginExample',
      component: () => import('@/components/examples/DialogPlugin.vue'),
      meta: { debug: true }
    },
  ]
}
]
